var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayIp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#96bd0d;}.cls-2{fill:#fff;}.cls-3{fill:#7a983a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Risorsa 49") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 55.5,
    cy: 55.5,
    r: 55.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 55.5,
    cy: 55.5,
    r: 50.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.5,
    y: 37.5,
    width: 44,
    height: 36,
    rx: 4.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.8,56.8,83.37,68.33A1.84,1.84,0,0,0,86.5,67V44a1.84,1.84,0,0,0-3.13-1.3L71.8,54.2A1.83,1.83,0,0,0,71.8,56.8Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIp);
export default __webpack_public_path__ + "static/media/play_ip.046241e205e0735e49699b063e0a23a1.svg";
export { ForwardRef as ReactComponent };